"use strict";

exports.__esModule = true;
exports.BoundingBoxAttachment = void 0;

var _Utils = require("../Utils");

var _Attachment = require("./Attachment");

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/** An attachment with vertices that make up a polygon. Can be used for hit detection, creating physics bodies, spawning particle
 * effects, and more.
 *
 * See {@link SkeletonBounds} and [Bounding Boxes](http://esotericsoftware.com/spine-bounding-boxes) in the Spine User
 * Guide. */
var BoundingBoxAttachment = /*#__PURE__*/function (_VertexAttachment) {
  _inheritsLoose(BoundingBoxAttachment, _VertexAttachment);

  function BoundingBoxAttachment(name) {
    var _this;

    _this = _VertexAttachment.call(this, name) || this;
    _this.color = new _Utils.Color(1, 1, 1, 1);
    return _this;
  }

  var _proto = BoundingBoxAttachment.prototype;

  _proto.copy = function copy() {
    var copy = new BoundingBoxAttachment(this.name);
    this.copyTo(copy);
    copy.color.setFromColor(this.color);
    return copy;
  };

  return BoundingBoxAttachment;
}(_Attachment.VertexAttachment);

exports.BoundingBoxAttachment = BoundingBoxAttachment;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7QUE2QkE7O0FBQ0E7Ozs7OztBQUVBOzs7OztJQUthQSxxQjs7O0VBR1osK0JBQWFDLElBQWIsRUFBeUI7SUFBQTs7SUFDeEIscUNBQU1BLElBQU47SUFIRCxjQUFRLElBQUlDLFlBQUosQ0FBVSxDQUFWLEVBQWEsQ0FBYixFQUFnQixDQUFoQixFQUFtQixDQUFuQixDQUFSO0lBRXlCO0VBRXhCOzs7O1NBRURDLEksR0FBQSxnQkFBSTtJQUNILElBQUlBLElBQUksR0FBRyxJQUFJSCxxQkFBSixDQUEwQixLQUFLQyxJQUEvQixDQUFYO0lBQ0EsS0FBS0csTUFBTCxDQUFZRCxJQUFaO0lBQ0FBLElBQUksQ0FBQ0UsS0FBTCxDQUFXQyxZQUFYLENBQXdCLEtBQUtELEtBQTdCO0lBQ0EsT0FBT0YsSUFBUDtFQUNBLEM7OztFQVp5Q0ksNEIiLCJuYW1lcyI6WyJCb3VuZGluZ0JveEF0dGFjaG1lbnQiLCJuYW1lIiwiQ29sb3IiLCJjb3B5IiwiY29weVRvIiwiY29sb3IiLCJzZXRGcm9tQ29sb3IiLCJWZXJ0ZXhBdHRhY2htZW50Il0sInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hdHRhY2htZW50cy9Cb3VuZGluZ0JveEF0dGFjaG1lbnQudHMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=